import { Component, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'D&D Twogether - Flowers and more';

  isLoggedIn$ = this.auth.currentUser$;
  constructor(public auth: AuthService, private translate: TranslateService) {
    this.translate.setDefaultLang('hu'); // Alapértelmezett nyelv
    const browserLang = this.translate.getBrowserLang();
    this.translate.use(browserLang?.match(/en|hu|ru/) ? browserLang : 'hu');
  }

  onLanguageChanged(language: string) {
    this.translate.use(language); // Nyelv váltása
  }
  
}
